/* global axios */
import ApiClient from './ApiClient';

class ProjectIssues extends ApiClient {
  constructor() {
    super('issues', { accountScoped: true });
    this.projectId = null;
  }

  get url() {
    return `${this.baseUrl()}/projects/${this.projectId}/issues`;
  }

  get(projectId) {
    this.projectId = projectId;
    return super.get();
  }

  create(projectId, data) {
    this.projectId = projectId;
    return super.create({ issue: data });
  }

  update(projectId, id, data) {
    this.projectId = projectId;
    return super.update(id, { issue: data });
  }

  delete(projectId, id) {
    this.projectId = projectId;
    return super.delete(id);
  }

  promoteToTask(projectId, id) {
    this.projectId = projectId;
    return axios.post(`${this.url}/${id}/promote_to_task`);
  }
}

export default new ProjectIssues();
